import type { Layout } from '../data/types';
import type { Vec2 } from '../geo/types';

/** Native painting: the round foot projects from the masonry head, with wrapping
 * stairs immediately on its bridge-facing side. Dimensions remain estimates. */
export const NIEUWE_BRUG_WEST_TOWER = {
  radius: 4.2,
  footRadius: 4.45,
  segments: 16,
  eaves: 11.5,
  apex: 18.3,
} as const;
export const NIEUWE_BRUG_WEST_STAIRS = { width: 5.5, treads: 4, rise: 0.2, going: 0.65 } as const;

export function nieuweBrugWestHead(layout: Layout) {
  const tower = layout.landmarks.find((l) => l.id === 'landmark-nieuwe-brug-west-tower');
  const bridge = layout.bridges.find((b) => b.id === 'bridge-nieuwe-brug');
  if (!tower || !bridge) return null;
  const dx = bridge.b[0] - bridge.a[0],
    dy = bridge.b[1] - bridge.a[1];
  const length = Math.hypot(dx, dy);
  const axis: Vec2 = [dx / length, dy / length];
  const outward: Vec2 = [-axis[1], axis[0]];
  const width = NIEUWE_BRUG_WEST_STAIRS.width,
    half = width / 2,
    gap = 0.12;
  const frontOffset = NIEUWE_BRUG_WEST_TOWER.footRadius + half + gap;
  const origin: Vec2 = [tower.pos[0] + axis[0] * frontOffset, tower.pos[1] + axis[1] * frontOffset];
  const across =
    (tower.pos[0] - bridge.a[0]) * outward[0] + (tower.pos[1] - bridge.a[1]) * outward[1];
  return {
    origin,
    heading: Math.atan2(outward[1], outward[0]),
    width,
    landing: across - bridge.width / 2,
    landingBackWidth: frontOffset + NIEUWE_BRUG_WEST_TOWER.footRadius,
    bridgeFlatEnd: (origin[0] - bridge.a[0]) * axis[0] + (origin[1] - bridge.a[1]) * axis[1] + half,
    stairRun: NIEUWE_BRUG_WEST_STAIRS.treads * NIEUWE_BRUG_WEST_STAIRS.going,
  };
}
